import { AxiosResponse }         from "axios";
import { oc }                    from "ts-optchain";
import { DealernetApi }          from "./DealernetApi";
import { IPromotionDto } from "@/types";

export class PromotionService {
    public static async getPromotion(id: number | string): Promise<IPromotionDto[]> {
        const response = await DealernetApi.client().request({
            method: "get",
            url: `Promotion/GetPromotion?id=${id}`,
        });
        const data = oc(response as AxiosResponse<IPromotionDto[]>).data([]);
        return data;
    }    
}